import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { SearchResultType } from 'Type/Search.type';

import SearchResultsTab from './SearchResultsTab.component';

/** @namespace PeggysagePwa/Component/SearchResultsTab/Container/mapStateToProps */
export const mapStateToProps = (_state) => ({
    // wishlistItems: state.WishlistReducer.productsInWishlist
});

/** @namespace PeggysagePwa/Component/SearchResultsTab/Container/mapDispatchToProps */
export const mapDispatchToProps = (_dispatch) => ({
    // addProduct: options => CartDispatcher.addProductToCart(dispatch, options)
});

/** @namespace PeggysagePwa/Component/SearchResultsTab/Container */
export class SearchResultsTabContainer extends PureComponent {
    static propTypes = {
        searchResult: SearchResultType.isRequired,
        isActive: PropTypes.bool,
        onClick: PropTypes.func
    };

    static defaultProps = {
        isActive: false,
        onClick: null
    };

    containerFunctions = {
        onTabClick: this.onTabClick.bind(this)
    };

    /**
     * @param {MouseEvent} e
     */
    onTabClick(e) {
        const { searchResult, onClick } = this.props;

        if (onClick) {
            onClick(searchResult, e);
        }
    }

    containerProps() {
        const { searchResult, isActive } = this.props;

        return {
            searchResult,
            isActive
        };
    }

    render() {
        return (
            <SearchResultsTab
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsTabContainer);
